import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import * as Util from '../../../common/utilities';

import { Spinner } from '@salesforce/design-system-react';
import { AssetTable, JobPanel, NoData, SelectionProfile } from '../';

import * as Shapes from '../../constants/shapes';

import './JobBrowser.scss';

class JobBrowser extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedJobId: null
    };
  }

  componentDidMount() {
    if (this.props.jobs?.length && this.state.selectedJobId === null) {
      this.setState({
        selectedJobId: this.props.jobs?.[0]?.send?.job_id
      });
    }
  }

  componentDidUpdate(prevProps) {
    if (Util.propChanged(prevProps, this.props, 'jobs')) {
      // Select the first job by default
      if (this.state.selectedJobId === null) {
        this.setState({
          selectedJobId: this.props.jobs?.[0]?.send?.job_id
        });
      }
    }
  }

  handleJobSelected(jobId) {
    this.setState({ selectedJobId: jobId });
  }

  renderAssetInfoRow(selectedJobDetails) {
    const count = selectedJobDetails?.blocks?.length || 0;
    return (
      <div className="asset-info-row">
        <h3>
          <FormattedMessage
            id="components.ecs.selectionBrowser.jobs.table.items"
            values={{ count }}
          />
        </h3>
      </div>
    );
  }

  renderBrowser() {
    const selectedJobDetails = this.props.jobs.find(
      j => j.send.job_id === this.state.selectedJobId
    );
    return (
      <div className="job-browser-root">
        <div className="job-browser">
          <SelectionProfile
            actions={this.props.actions}
            auditLog={this.props.auditLog}
            profile={this.props.profile}
            location={this.props.location}
            subscriber={this.props.subscriber}
            flags={this.props.flags}
            rules={this.props.rules}
            isLoading={this.props.isLoading}
          />
          <JobPanel
            actions={this.props.actions}
            subscriber={this.props.subscriber}
            profile={this.props.profile}
            jobs={this.props.jobs}
            isLoading={this.props.isLoading}
            selectedJobId={this.state.selectedJobId}
            onJobSelected={this.handleJobSelected.bind(this)}
          />
          <div className="asset-pane">
            <h1>
              <FormattedMessage id="components.ecs.selectionBrowser.jobs.table.header" />
            </h1>
            {this.renderAssetInfoRow(selectedJobDetails)}
            <AssetTable
              actions={this.props.actions}
              job={selectedJobDetails}
              isLoading={this.props.isLoading}
              subscriber={this.props.subscriber}
              history={this.props.history}
            />
          </div>
        </div>
      </div>
    );
  }

  renderNoData() {
    return (
      <div>
        <NoData
          screen="selections"
          helpLink="https://help.salesforce.com/articleView?id=sf.mc_pb_find_out_why_an_asset_was_selected.htm&type=5"
        />
        {this.props.isLoading ? (
          <div className="pi-common-spinner">
            <Spinner variant="brand" />
          </div>
        ) : null}
      </div>
    );
  }

  render() {
    return this.props.profile ? this.renderBrowser() : this.renderNoData();
  }
}

JobBrowser.contextTypes = {
  router: PropTypes.object
};

JobBrowser.propTypes = {
  actions: PropTypes.object,
  auditLog: PropTypes.array,
  location: Shapes.Location,
  profile: Shapes.Profile,
  history: PropTypes.object.isRequired,
  isLoading: PropTypes.bool,
  jobs: PropTypes.array,
  flags: Shapes.Flags,
  rules: PropTypes.object,
  subscriber: PropTypes.string
};

export default injectIntl(JobBrowser);
